module.exports = __webpack_public_path__ + "static/img/5.47baa2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/eng/5.png
// module id = rzQv
// module chunks = 0